import { RouteInfo } from './vertical-menu.metadata';

// Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [
    {
        path: '/overview',
        title: 'Overview',
        icon: 'ft-bar-chart-line',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
    },
    {
        path: '/projects',
        title: 'Projects',
        icon: 'ft-box',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
    },

    {
        path: '/assets',
        title: 'Assets',
        icon: 'ft-layers',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
    },
    {
        path: '/contracts',
        title: 'Deploy Contract',
        icon: 'ft-send',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
    },
    {
        path: '/momint-internal',
        title: 'Momint Internal',
        icon: 'ft-settings',
        class: 'has-sub',
        isExternalLink: false,
        roles: ['B2B_ADMIN'],
        submenu: [
            {
                path: '/payouts',
                title: 'Swaps',
                icon: 'ft-dollar-sign',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/accounts',
                title: 'Accounts',
                icon: 'ft-users',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/top-up',
                title: 'Top-up Balances',
                icon: 'icon-wallet',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/payments',
                title: 'Payments',
                icon: 'ft-credit-card',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/transactions',
                title: 'Transactions',
                icon: 'icon-wallet',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/transfers',
                title: 'Transfers',
                icon: 'ft-upload-cloud',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/airdrops',
                title: 'Airdrops',
                icon: 'ft-download-cloud',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/mints',
                title: 'Mints',
                icon: 'ft-gift',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/payment-verification',
                title: 'Payment verification',
                icon: 'ft-check-square',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
            {
                path: '/emails',
                title: 'Emails',
                icon: 'ft-mail',
                class: 'dropdown nav-item',
                isExternalLink: false,
                submenu: [],
            },
        ],
    },
    {
        path: '/settings',
        title: 'Settings',
        icon: 'ft-settings',
        class: 'dropdown nav-item',
        isExternalLink: false,
        submenu: [],
    },
];
